import { PharmacistLayout } from "@/components/layout/pharmacist-layout";
import { EventsList } from "@/components/events/events-list";

export default function PharmacistEvents() {
  return (
    <PharmacistLayout title="Events">
      <EventsList
        intro="RPS events, CPPE study days, GPhC-recognised CPD, BSR pharmacy sessions, and prescribing updates — UK pharmacy events relevant to rheumatology in one place."
        accentBg="bg-emerald-100"
        accentIcon="text-emerald-700"
        accentLink="text-emerald-600 hover:text-emerald-800"
      />
    </PharmacistLayout>
  );
}
